import {getJsTranslations} from "./site-vars";

export function getTranslation(key) {
    return getJsTranslations()[key] || '';
}

/** Format gettext positional placeholders without evaluating replacement text. */
export function formatTranslation(key, ...values) {
    return getTranslation(key).replace(/%(\d+)\$s/g, (placeholder, position) => {
        const index = Number(position) - 1;
        if (index < 0 || index >= values.length) {
            throw new RangeError(`Missing argument ${position} for translation ${key}`);
        }
        return String(values[index]);
    });
}

export function escapeHtml(value) {
    return String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
}
